import { setColor, setFillColorType, setShouldFillColor } from "store/features/enlarge/actions";
import { useAppSelector, useAppDispatch } from "store/store";
import { enlargeSelector } from "store/features/enlarge/selectors/enlargeSelector";
import { EnlargeState } from "store/features/enlarge/types";

export const useFillColor = () => {
    const {
        resizeSettings: {
            fillColor: { color, shouldFillColor, type },
        },
    } = useAppSelector(enlargeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleColorChange = (color: string) => dispatch(setColor(color));

    const handleShouldFillColorChange = (value: boolean) =>
        dispatch(setShouldFillColor(value));

    const handleFillColorTypeChange = (value: EnlargeState["resizeSettings"]["fillColor"]["type"]) => dispatch(setFillColorType(value));

    return {
        shouldFillColor,
        color,
        handleColorChange,
        handleShouldFillColorChange,
        type,
        handleFillColorTypeChange
    };
};

const equalityFn = (
    left: EnlargeState,
    right: EnlargeState
) => {
    if (
        JSON.stringify(left.resizeSettings.fillColor) !==
        JSON.stringify(right.resizeSettings.fillColor)
    )
        return false;

    return true;
};
